/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { ref, Ref } from '@vue/composition-api';
import { getGalileoAb } from '@/shared/galileoAb';
import { ABResEnum } from '@/enums/abExperiment';

/** 首页授信按钮实验返回值类型 */
interface UseAmountButtonAbReturn {
  /** 首页申请额度文案 */
  amountButtonText: Ref<string | undefined>;
  /** 首页申请额度按钮动效 */
  showPulseAnimation: Ref<boolean>;
  /** 首页申请额度文案测试 */
  getAmountButtonTextAb: () => Promise<void>;
  /** 首页申请额度按钮动效测试 */
  getAmountButtonAnimationAb: () => Promise<void>;
}

/** 首页授信按钮文案映射 */
export const HOME_AMOUNT_BUTTON_TEXT_MAP = {
  /** 对照组 */
  [ABResEnum.WAITHINT]: '申请额度',
  /** 实验组1 */
  [ABResEnum.HINT]: '查看额度',
  /** 实验组2 */
  [ABResEnum.HINT2]: '测一测额度',
};

/** 首页授信按钮实验 hooks */
export function useAmountButtonAb(): UseAmountButtonAbReturn {
  /** 首页申请额度文案 */
  const amountButtonText = ref<string>();
  /** 是否展示呼吸动画 */
  const showPulseAnimation = ref<boolean>(false);

  /** 首页申请额度文案测试，https://ab.hellobike.cn/experiment/detail/202601261055148791?isDetail=true */
  const getAmountButtonTextAb = async () => {
    const res = await getGalileoAb().getAbResCatchError('202601261055148791', '202601261055148933');

    const resultKey = res.result as keyof typeof HOME_AMOUNT_BUTTON_TEXT_MAP;
    const isValidKey = Object.prototype.hasOwnProperty.call(HOME_AMOUNT_BUTTON_TEXT_MAP, resultKey);
    const key = isValidKey ? resultKey : ABResEnum.WAITHINT;

    amountButtonText.value = HOME_AMOUNT_BUTTON_TEXT_MAP[key];
  };

  /** 首页申请额度按钮动效测试，https://ab.hellobike.cn/experiment/detail/202601261057515038?isDetail=true */
  const getAmountButtonAnimationAb = async () => {
    const res = await getGalileoAb().getAbResCatchError('202601261057515038', '202601261057515192');
    showPulseAnimation.value = res.result === ABResEnum.HINT;
  };

  return {
    amountButtonText,
    showPulseAnimation,
    getAmountButtonTextAb,
    getAmountButtonAnimationAb,
  };
}
